import { createContext } from 'react';
import type { TrackingProp } from '../types';
import type { InputProps } from '../input/input';
import { useTracking } from '../utils';

export const InputGroupContext = createContext(
  {} as {
    useGroupProps: (props: InputProps) => void;
    setValue: (
      input: HTMLInputElement,
      values: string[],
      tracking?: TrackingProp
    ) => void;
    track: ReturnType<typeof useTracking>;
  }
);
